import { render, staticRenderFns } from "./CollectionModal.vue?vue&type=template&id=65afb098&scoped=true"
import script from "./CollectionModal.vue?vue&type=script&lang=js"
export * from "./CollectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afb098",
  null
  
)

export default component.exports